/** The radius range the API accepts (ClinicGeocodingController / CustomersController validate 1–500). */
export const MIN_RADIUS_MILES = 1;
export const MAX_RADIUS_MILES = 500;

/** SLV2-3509: parse a typed radius; returns whole miles in range, or null when the text is not valid. */
export function parseRadiusMiles(text: string): number | null {
  const t = text.trim();
  if (!/^\d+$/.test(t)) return null;
  const n = Number(t);
  return n >= MIN_RADIUS_MILES && n <= MAX_RADIUS_MILES ? n : null;
}
